import { TYPES } from "./types";
import { permissionService } from "../services/permissionService";

export const fetchPermissions = () => async (dispatch) => {
  try {
    dispatch({ type: TYPES.ACTION_GET_PERMISSIONS_LOADING });
    const result = await permissionService.fetchPermissions();
    const data = result.data.data;
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_PERMISSIONS_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_PERMISSIONS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_GET_PERMISSIONS_FAIL,
      payload: { message: error },
    });
  }
}; 